import FormInput from "@/components/formControls/FormInput";
import Button from "@/components/ui/Button";
import FormAgreements from "@/components/formControls/FormAgreements";
import { LeadFormFieldsType } from "@/types/LeadFormFieldsType";
import { UseFormReturn } from "react-hook-form";
import { AgreementsDataType } from "@/types/AgreementsDataType";
import { ReactElement, RefObject } from "react";
import ReCAPTCHA from "react-google-recaptcha";

export default function LeadForm({
  form,
  agreements,
  onSubmit,
  cta,
  reCaptcha,
}: React.PropsWithChildren<{
  form: UseFormReturn<LeadFormFieldsType>;
  agreements: AgreementsDataType[];
  onSubmit: (data: LeadFormFieldsType) => void;
  cta?: string | ReactElement;
  reCaptcha?: RefObject<ReCAPTCHA | null>;
}>) {
  const siteKey = process.env.RECAPTCHA_SITE_KEY as string;

  return (
    <form onSubmit={form.handleSubmit(onSubmit)}>
      {!1 && <ReCAPTCHA ref={reCaptcha} size="invisible" sitekey={siteKey} />}
      <div className="mb-7 space-y-2.5 lg:space-y-5">
        <FormInput
          label="Imię"
          placeholder="Twoje imię"
          name="firstName"
          register={form.register}
          error={form.formState.errors.firstName}
        />
        <FormInput
          label="Telefon"
          placeholder="Twój numer telefonu"
          name="phone"
          register={form.register}
          error={form.formState.errors.phone}
          mask="+48 999 999 999"
        />
        <FormInput
          label="Email"
          placeholder="Twój adres email"
          name="email"
          register={form.register}
          error={form.formState.errors.email}
        />
        {/*<FormTextarea*/}
        {/*  label="Wiadomość"*/}
        {/*  placeholder="Twoja wiadomość"*/}
        {/*  name="message"*/}
        {/*  rows={3}*/}
        {/*  register={form.register}*/}
        {/*  error={form.formState.errors.message}*/}
        {/*/>*/}
      </div>
      <Button
        type="submit"
        className="my-10 !w-full"
        loading={form.formState.isSubmitting}
      >
        {cta ?? "Zapytaj o ofertę"}
      </Button>
      <FormAgreements
        agreements={agreements}
        form={form}
        checkAll={"Zaznacz wszystkie zgody"}
      />
    </form>
  );
}
